import React from "react";

const PromosCard = ({ promo }) => {

    return (
        <div className="card mb-3" style={{ width: '900px' }}>
            <div className="row g-0">
                <div className="col-md-4">
                    <img src={promo.img} className="card-img" alt="..." />
                </div>
                <div className="col-md-8 d-flex align-items-center">
                    <div className="card-body">
                        <h4 className="card-title">{promo.name}</h4>
                        <p className="card-text">Código de promoción: {promo.code}</p>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default PromosCard;